import {
  useContext,
} from 'react';
import styled from "styled-components";

import { ThemeContext } from '@dstantwo/ullr-react-components';

export const ModalHeader = styled.div`
  display: flex;
  flex: 0;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: ${() => useContext(ThemeContext).COLORS.TRANSPARENT}
`;
export const ModalBody = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 16px;
  background: ${() => useContext(ThemeContext).COLORS.TRANSPARENT}
`;

export const ModalTitle = styled.span`
  color: ${() => useContext(ThemeContext).COLORS.DARK};
  font-size: 1.25em;
  font-weight: bold;
`

export const CloseButton = styled.button`
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border: 0;
  outline: 0;
  height: 40px;
  line-height: 40px;
  padding: 0 14px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  color: ${() => useContext(ThemeContext).COLORS.DARK};
  font-size: 15px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  background-color: ${() => useContext(ThemeContext).COLORS.TRANSPARENT};
  text-decoration: none;
  -webkit-transition: all 150ms ease;
  transition: all 150ms ease;

  &:hover {
    color: ${() => useContext(ThemeContext).COLORS.DARK};
    cursor: pointer;
    transform: translateY(-1px);
    box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-self: stretch;
  justify-content: flex-end;
  margin-top: 24;
`;